import { Card, Switch, Stack, Text, Group, Button } from '@mantine/core';
import { useDatabaseLock } from '../../core/database-lock/DatabaseLockProvider';
import React, { useEffect, useState } from 'react';

export const DatabaseLock = () => {
  const { isLocked, loading, toggleLock } = useDatabaseLock();
  const [checked, setChecked] = useState(isLocked);

  const handleSave = async () => {
    await toggleLock(checked);
  };

  useEffect(() => {
    setChecked(isLocked);
  }, [isLocked]);

  return (
    <Card shadow="sm" p="lg" radius="md" withBorder>
      <Stack gap="xs">
        <Switch
          label="Zamknout celou databázi"
          checked={checked}
          onChange={(e) => setChecked(!checked)}
          color="dpkk-blue"
          size="md"
          disabled={loading}
        />
        <Text size="sm" c="dimmed">
          Pokud aktivní, v databázi nebude možné přidávat či upravovat data. Bude je však možné
          exportovat.
        </Text>
        <Group justify="flex-start">
          <Button bg={'dpkk-blue'} onClick={handleSave} radius={10} disabled={loading}>
            Uložit
          </Button>
        </Group>
      </Stack>
    </Card>
  );
};
